import { render, staticRenderFns } from "./AddPhoneExtension.vue?vue&type=template&id=8c0ff83c"
import script from "./AddPhoneExtension.vue?vue&type=script&lang=js"
export * from "./AddPhoneExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports